// Future Task Generic methods to get, set and be informed if something changes?
// Future Task Look at Stencil Store GitHub to see how they make sure get() and set() only allows correct types
// Future Task After we use Benedikts config approach we can get all of the bots state in here

type Subscriber<T> = (value: T) => any;
type OpenedBy = HTMLElement | null;
interface State {
    open: boolean;
    onOpen: Subscriber<void>[];
    onClose: Subscriber<OpenedBy>[];
    openedBy: OpenedBy;
}

class Store {
    private createDefaultState(): State {
        return {
            open: false,
            onOpen: [],
            onClose: [],
            openedBy: null,
        };
    }

    private state: State = this.createDefaultState();

    reset() {
        this.state = this.createDefaultState();
    }

    isOpen(): boolean {
        return this.state.open;
    }

    wasOpenedBy(): HTMLElement | null {
        return this.state.openedBy;
    }

    openChatbot(openedBy?: HTMLElement) {
        if (this.state.open) {
            return;
        }
        this.state.open = true;
        if (openedBy) {
            this.state.openedBy = openedBy;
        }
        this.state.onOpen.forEach((subscriber) => subscriber());
    }

    onOpen(subscriber: Subscriber<void>) {
        this.state.onOpen.push(subscriber);
    }

    closeChatbot() {
        if (!this.state.open) {
            return;
        }
        this.state.open = false;
        this.state.onClose.forEach((subscriber) =>
            subscriber(this.state.openedBy)
        );
        // Settings openedBy to null has to be last, so subscribers of the close event can still know who opened the chatbot
        this.state.openedBy = null;
    }

    onClose(subscriber: Subscriber<OpenedBy>) {
        this.state.onClose.push(subscriber);
    }
}

export default new Store();
